/** Real MIZU menu — imported from current printed menus. No product photos yet. */

function i(
  id,
  categoryId,
  nameHu,
  nameEn,
  descHu,
  descEn,
  price,
  featured = false,
  extras = {}
) {
  const description = {
    hu: descHu || "",
    en: descEn || descHu || "",
  };
  return {
    id,
    categoryId,
    featured,
    name: { hu: nameHu, en: nameEn || nameHu },
    description,
    fullDescription: description,
    price,
    image: null,
    ...extras,
  };
}

export const menuCategories = [
  { id: "brunch", group: "food", label: { hu: "Brunch", en: "Brunch" } },
  {
    id: "sandwiches",
    group: "food",
    label: { hu: "Szendvicsek", en: "Sandwiches" },
  },
  { id: "tapas", group: "food", label: { hu: "Tapas", en: "Tapas" } },
  {
    id: "bowls",
    group: "food",
    label: { hu: "Joghurt & Granola", en: "Yogurt & Granola" },
  },
  { id: "waffles", group: "food", label: { hu: "Gofri", en: "Waffles" } },
  {
    id: "dessert",
    group: "food",
    label: { hu: "Desszert", en: "Dessert" },
    note: {
      hu: "Desszertjeink további kínálatát megtalálja hűtővitrinünkben, vagy forduljon bizalommal kollégáinkhoz – örömmel segítenek a választásban!",
      en: "More desserts are available in our display case — ask our team for help choosing!",
    },
  },
  {
    id: "coffee",
    group: "drink",
    label: { hu: "Kávé", en: "Coffee" },
    note: {
      hu: "Alternatív tejek: Zab, Kókusz, Szója, Mandula — dl / 350.-",
      en: "Alt milks: Oat, Coconut, Soy, Almond — dl / 350.-",
    },
  },
  {
    id: "matcha",
    group: "drink",
    label: { hu: "Matcha & Chai", en: "Matcha & Chai" },
  },
  {
    id: "iced",
    group: "drink",
    label: { hu: "Jeges italok", en: "Iced drinks" },
  },
  { id: "tea", group: "drink", label: { hu: "Tea", en: "Tea" } },
  { id: "soft", group: "drink", label: { hu: "Üdítők", en: "Soft drinks" } },
  {
    id: "juice",
    group: "drink",
    label: { hu: "Fresh Juice", en: "Fresh Juice" },
  },
  { id: "beer", group: "drink", label: { hu: "Sörök", en: "Beers" } },
  {
    id: "cocktails",
    group: "drink",
    label: { hu: "Koktélok", en: "Cocktails" },
  },
  {
    id: "spirits",
    group: "drink",
    label: { hu: "Spirit", en: "Spirits" },
    note: { hu: "4 cl", en: "4 cl" },
  },
  {
    id: "wine",
    group: "drink",
    label: { hu: "Bor & Pezsgő", en: "Wine & Sparkling" },
    note: { hu: "Árak: dl / üveg", en: "Prices: glass / bottle" },
  },
];

export function getCategoriesForGroup(group) {
  return menuCategories.filter((category) => category.group === group);
}

export const menuItems = [
  // —— Food ——
  i(
    "seasonal-soup",
    "brunch",
    "Szezonális krémleves",
    "Seasonal cream soup",
    "",
    "",
    "1990.-",
    true
  ),
  i(
    "eggs-benedict",
    "brunch",
    "Eggs Benedict",
    "Eggs Benedict",
    "Vajas croissant, buggyantott tojás, hollandi mártás, füstölt lazac / pármai sonka",
    "Buttery croissant, poached egg, hollandaise, smoked salmon / Parma ham",
    "4690.-",
    true
  ),
  i(
    "avocado-bowl",
    "brunch",
    "Avocado Bowl",
    "Avocado Bowl",
    "Avokádó, paradicsom, uborka, edamame, fekete szezámmag, retek, olívaolaj, füstölt lazac",
    "Avocado, tomato, cucumber, edamame, black sesame, radish, olive oil, smoked salmon",
    "4490.-",
    true
  ),
  i(
    "la-burrata",
    "brunch",
    "La Burrata",
    "La Burrata",
    "Burrata, paradicsom, lilahagyma, rukkola, fenyőmag, pármai sonka, balzsamecetkrém",
    "Burrata, tomato, red onion, rocket, pine nuts, Parma ham, balsamic cream",
    "4490.-",
    true
  ),

  i(
    "caprese",
    "sandwiches",
    "Caprese",
    "Caprese",
    "Ciabatta, mozzarella, paradicsom, bazsalikom, pesto, olívaolaj",
    "Ciabatta, mozzarella, tomato, basil, pesto, olive oil",
    "2490.-",
    true
  ),
  i(
    "avocado-egg",
    "sandwiches",
    "Avocado & Egg",
    "Avocado & Egg",
    "Ciabatta, avokádó, lágy főtt tojás, fekete szezámmag, chilipehely",
    "Ciabatta, avocado, soft-boiled egg, black sesame, chili flakes",
    "2790.-",
    true
  ),
  i(
    "mortadella-pistachio",
    "sandwiches",
    "Mortadella & Pisztácia",
    "Mortadella & Pistachio",
    "Ciabatta, mortadella, pisztáciakrém, rukkola, mozzarella, olívaolaj",
    "Ciabatta, mortadella, pistachio cream, rocket, mozzarella, olive oil",
    "3190.-",
    true
  ),
  i(
    "smoked-salmon",
    "sandwiches",
    "Smoked Salmon",
    "Smoked Salmon",
    "Ciabatta, füstölt lazac, krémsajt, rukkola, olívaolaj, kapribogyó, lilahagyma",
    "Ciabatta, smoked salmon, cream cheese, rocket, olive oil, capers, red onion",
    "3390.-",
    true
  ),
  i(
    "goat-bresaola",
    "sandwiches",
    "Kecskesajt & Bresaola",
    "Goat cheese & Bresaola",
    "Ciabatta, kecskesajtkrém, bresaola, rukkola, balzsamecetkrém, olívaolaj",
    "Ciabatta, goat cheese cream, bresaola, rocket, balsamic cream, olive oil",
    "3390.-",
    true
  ),

  i(
    "mizu-tapas",
    "tapas",
    "Mizu Tapas válogatás",
    "Mizu Tapas selection",
    "Ciabatta, pármai sonka, burrata, padlizsánkrém, hummus, zöldségek",
    "Ciabatta, Parma ham, burrata, eggplant cream, hummus, vegetables",
    "5190.-",
    true
  ),

  i(
    "berry-bliss",
    "bowls",
    "Berry Bliss Bowl",
    "Berry Bliss Bowl",
    "Açai, granola, banán, eper, áfonya, kókuszchips, méz",
    "Açai, granola, banana, strawberry, blueberry, coconut chips, honey",
    "4490.-",
    true
  ),
  i(
    "peanut-power",
    "bowls",
    "Peanut Power Bowl",
    "Peanut Power Bowl",
    "Açai, granola, banán, mogyoróvaj, chia mag, kókuszchips, méz",
    "Açai, granola, banana, peanut butter, chia seeds, coconut chips, honey",
    "4690.-",
    true
  ),

  i(
    "waffle-pistachio",
    "waffles",
    "Pisztácia Málna",
    "Pistachio Raspberry",
    "Pisztáciakrém, juharszirup, málna",
    "Pistachio cream, maple syrup, raspberry",
    "3690.-",
    true
  ),
  i(
    "waffle-nutella",
    "waffles",
    "Nutella Eper",
    "Nutella Strawberry",
    "Nutella, eper, tejszínhab, étcsokoládé",
    "Nutella, strawberry, whipped cream, dark chocolate",
    "3390.-",
    true
  ),
  i(
    "waffle-lotus",
    "waffles",
    "Lotus Biscoff",
    "Lotus Biscoff",
    "Lotuskrém, biscoff keksz, fahéj",
    "Lotus cream, Biscoff cookie, cinnamon",
    "3390.-",
    true
  ),
  i(
    "waffle-mortadella",
    "waffles",
    "Mortadella",
    "Mortadella",
    "Mortadella, gorgonzola, mozzarella, pisztácia",
    "Mortadella, gorgonzola, mozzarella, pistachio",
    "3190.-",
    true
  ),
  i(
    "waffle-spinach",
    "waffles",
    "Spenótos-Fetás",
    "Spinach & Feta",
    "Spenót, feta, aszalt paradicsom, fenyőmag",
    "Spinach, feta, sun-dried tomato, pine nuts",
    "2890.-",
    true
  ),

  i(
    "pistachio-tiramisu",
    "dessert",
    "Pisztáciás Tiramisu",
    "Pistachio Tiramisu",
    "",
    "",
    "2690.-",
    true
  ),

  // —— Coffee ——
  i("ristretto", "coffee", "Ristretto", "Ristretto", "", "", "890.-", true),
  i("espresso", "coffee", "Espresso", "Espresso", "", "", "990.-", true),
  i(
    "espresso-macchiato",
    "coffee",
    "Espresso Macchiato",
    "Espresso Macchiato",
    "",
    "",
    "990.-"
  ),
  i("americano", "coffee", "Americano", "Americano", "", "", "990.-"),
  i("doppio", "coffee", "Doppio", "Doppio", "", "", "1390.-"),
  i("cappuccino", "coffee", "Cappuccino", "Cappuccino", "", "", "1490.-", true),
  i("cortado", "coffee", "Cortado", "Cortado", "", "", "1290.-"),
  i("flat-white", "coffee", "Flat White", "Flat White", "", "", "1590.-", true),
  i("latte", "coffee", "Latte", "Latte", "", "", "1690.-", true),
  i("melange", "coffee", "Melange", "Melange", "", "", "1690.-"),
  i("barraquito", "coffee", "Barraquito", "Barraquito", "", "", "2190.-"),
  i("carajillo", "coffee", "Carajillo", "Carajillo", "", "", "990.-"),

  // —— Matcha & Chai ——
  i(
    "matcha-latte",
    "matcha",
    "Matcha Latte",
    "Matcha Latte",
    "",
    "",
    "1890.-",
    true
  ),
  i(
    "dirty-matcha",
    "matcha",
    "Dirty Matcha",
    "Dirty Matcha",
    "",
    "",
    "2290.-",
    true
  ),
  i("chai-latte", "matcha", "Chai Latte", "Chai Latte", "", "", "1790.-", true),
  i(
    "dirty-chai",
    "matcha",
    "Dirty Chai Latte",
    "Dirty Chai Latte",
    "",
    "",
    "2190.-",
    true
  ),

  // —— Iced ——
  i("iced-latte", "iced", "Iced Latte", "Iced Latte", "", "", "1790.-", true),
  i(
    "iced-dirty-matcha",
    "iced",
    "Iced Dirty Matcha Latte",
    "Iced Dirty Matcha Latte",
    "",
    "",
    "2290.-",
    true
  ),
  i(
    "iced-dirty-chai",
    "iced",
    "Iced Dirty Chai Latte",
    "Iced Dirty Chai Latte",
    "",
    "",
    "2190.-",
    true
  ),
  i(
    "espresso-tonic",
    "iced",
    "Espresso Tonic",
    "Espresso Tonic",
    "",
    "",
    "1990.-",
    true
  ),

  // —— Tea ——
  i("tea-green", "tea", "Zöld", "Green", "", "", "1490.-", true),
  i("tea-black", "tea", "Fekete", "Black", "", "", "1490.-", true),
  i("tea-hibiscus", "tea", "Hibiszkusz", "Hibiscus", "", "", "1490.-", true),
  i(
    "tea-blood-orange",
    "tea",
    "Vérnarancs",
    "Blood orange",
    "",
    "",
    "1490.-",
    true
  ),
  i(
    "tea-rooibos",
    "tea",
    "Rooibos Karamell",
    "Rooibos Caramel",
    "",
    "",
    "1490.-",
    true
  ),

  // —— Soft ——
  i("coca-cola", "soft", "Coca Cola", "Coca Cola", "", "", "990.-", true),
  i(
    "coca-cola-zero",
    "soft",
    "Coca Cola Zero",
    "Coca Cola Zero",
    "",
    "",
    "990.-",
    true
  ),
  i(
    "kinley-ginger",
    "soft",
    "Kinley Gyömbér",
    "Kinley Ginger",
    "",
    "",
    "990.-"
  ),
  i("kinley-tonic", "soft", "Kinley Tonic", "Kinley Tonic", "", "", "990.-"),
  i(
    "lemon-aranciata",
    "soft",
    "Lemon Soda Aranciata",
    "Lemon Soda Aranciata",
    "",
    "",
    "990.-"
  ),
  i(
    "fever-tree",
    "soft",
    "Fever-Tree Mediterranean Tonic",
    "Fever-Tree Mediterranean Tonic",
    "",
    "",
    "1490.-",
    true
  ),
  i(
    "lemon-limonata",
    "soft",
    "Lemon Soda Limonata",
    "Lemon Soda Limonata",
    "",
    "",
    "990.-"
  ),
  i(
    "natur-aqua",
    "soft",
    "Natur Aqua mentes / dús",
    "Natur Aqua still / sparkling",
    "",
    "",
    "890.-",
    true
  ),
  i("kombucha", "soft", "Kombucha", "Kombucha", "", "", "1490.-", true),

  // —— Juice ——
  i(
    "orange-juice",
    "juice",
    "Narancs Juice",
    "Orange Juice",
    "",
    "",
    "1190.-",
    true
  ),
  i("green-juice", "juice", "Green Juice", "Green Juice", "", "", "1290.-", true),
  i("ginger-shot", "juice", "Ginger Shot", "Ginger Shot", "", "", "990.-", true),

  // —— Beer ——
  i(
    "birra-moretti",
    "beer",
    "Birra Moretti",
    "Birra Moretti",
    "",
    "",
    "1590.-",
    true
  ),
  i(
    "estrella-damm",
    "beer",
    "Estrella Damm",
    "Estrella Damm",
    "",
    "",
    "1590.-",
    true
  ),
  i(
    "ginger-beer",
    "beer",
    "Gyömbérsör",
    "Ginger beer",
    "",
    "",
    "1490.-",
    true
  ),

  // —— Cocktails ——
  i(
    "limoncello-spritz",
    "cocktails",
    "Limoncello Spritz",
    "Limoncello Spritz",
    "",
    "",
    "2990.-",
    true
  ),
  i(
    "aperol-spritz",
    "cocktails",
    "Aperol Spritz",
    "Aperol Spritz",
    "",
    "",
    "2990.-",
    true
  ),
  i(
    "campari-spritz",
    "cocktails",
    "Campari Spritz",
    "Campari Spritz",
    "",
    "",
    "2990.-"
  ),
  i("gin-tonic", "cocktails", "Gin & Tonic", "Gin & Tonic", "", "", "2990.-", true),
  i(
    "espresso-martini",
    "cocktails",
    "Espresso Martini",
    "Espresso Martini",
    "",
    "",
    "3190.-",
    true
  ),
  i(
    "pornstar-martini",
    "cocktails",
    "Pornstar Martini",
    "Pornstar Martini",
    "",
    "",
    "3290.-"
  ),
  i("moscow-mule", "cocktails", "Moscow Mule", "Moscow Mule", "", "", "2890.-"),
  i("negroni", "cocktails", "Negroni", "Negroni", "", "", "2990.-", true),
  i("mimosa", "cocktails", "Mimosa", "Mimosa", "", "", "1990.-", true),

  // —— Spirits ——
  i("tanqueray", "spirits", "Tanqueray Gin", "Tanqueray Gin", "", "", "1490.-", true),
  i(
    "monkey-47",
    "spirits",
    "Monkey 47 Gin",
    "Monkey 47 Gin",
    "",
    "",
    "3890.-",
    true
  ),
  i("absolut", "spirits", "Absolut Vodka", "Absolut Vodka", "", "", "1390.-", true),
  i(
    "grey-goose",
    "spirits",
    "Grey Goose Vodka",
    "Grey Goose Vodka",
    "",
    "",
    "3590.-"
  ),
  i(
    "jack-daniels",
    "spirits",
    "Jack Daniel's Old No. 7",
    "Jack Daniel's Old No. 7",
    "",
    "",
    "1390.-",
    true
  ),
  i(
    "plantation",
    "spirits",
    "Plantation Grande Reserve Barbados",
    "Plantation Grande Reserve Barbados",
    "",
    "",
    "1590.-"
  ),
  i(
    "takamaka",
    "spirits",
    "Takamaka Overproof Rum",
    "Takamaka Overproof Rum",
    "",
    "",
    "1890.-"
  ),
  i(
    "el-jimador",
    "spirits",
    "El Jimador Blanco Tequila",
    "El Jimador Blanco Tequila",
    "",
    "",
    "1490.-",
    true
  ),

  // —— Wine (dl / bottle) ——
  i(
    "bolyki-sb",
    "wine",
    "Bolyki Sauvignon Blanc",
    "Bolyki Sauvignon Blanc",
    "Fehérbor",
    "White wine",
    "1190.- / 6990.-",
    true,
    { priceNote: { hu: "dl / üveg", en: "glass / bottle" } }
  ),
  i(
    "sauska-chardonnay",
    "wine",
    "Sauska Chardonnay",
    "Sauska Chardonnay",
    "Fehérbor",
    "White wine",
    "1690.- / 9990.-",
    true,
    { priceNote: { hu: "dl / üveg", en: "glass / bottle" } }
  ),
  i(
    "skizo-irsai",
    "wine",
    "Skizo Irsai",
    "Skizo Irsai",
    "Fehérbor",
    "White wine",
    "1190.- / 6990.-",
    false,
    { priceNote: { hu: "dl / üveg", en: "glass / bottle" } }
  ),
  i(
    "martinius",
    "wine",
    "Martinius Olaszrizling",
    "Martinius Olaszrizling",
    "Fehérbor",
    "White wine",
    "1290.- / 7190.-",
    false,
    { priceNote: { hu: "dl / üveg", en: "glass / bottle" } }
  ),
  i(
    "ikon-allstars",
    "wine",
    "Ikon Allstars Gyöngyözőbor",
    "Ikon Allstars sparkling wine",
    "Fehérbor",
    "White wine",
    "1490.- / 7990.-",
    false,
    { priceNote: { hu: "dl / üveg", en: "glass / bottle" } }
  ),
  i(
    "bela-bandi-rose",
    "wine",
    "Béla és Bandi Kékfrankos Merlot",
    "Béla és Bandi Kékfrankos Merlot",
    "Rosé",
    "Rosé",
    "1090.- / 6590.-",
    true,
    { priceNote: { hu: "dl / üveg", en: "glass / bottle" } }
  ),
  i(
    "etyeki-kuria-rose",
    "wine",
    "Etyeki Kúria Rosé",
    "Etyeki Kúria Rosé",
    "Rosé",
    "Rosé",
    "990.- / 6290.-",
    false,
    { priceNote: { hu: "dl / üveg", en: "glass / bottle" } }
  ),
  i(
    "sauska-siller",
    "wine",
    "Sauska Siller",
    "Sauska Siller",
    "Vörösbor",
    "Red wine",
    "1490.- / 7990.-",
    true,
    { priceNote: { hu: "dl / üveg", en: "glass / bottle" } }
  ),
  i(
    "takler-kadarka",
    "wine",
    "Takler Örökség Kadarka",
    "Takler Örökség Kadarka",
    "Vörösbor",
    "Red wine",
    "1890.- / 11990.-",
    false,
    { priceNote: { hu: "dl / üveg", en: "glass / bottle" } }
  ),
  i(
    "kreinbacher",
    "wine",
    "Kreinbacher Brut Classic",
    "Kreinbacher Brut Classic",
    "Pezsgő",
    "Sparkling",
    "21990.-",
    true,
    { priceNote: { hu: "üveg", en: "bottle" } }
  ),
  i(
    "bortolomiol",
    "wine",
    "Bortolomiol Prosecco",
    "Bortolomiol Prosecco",
    "Prosecco",
    "Prosecco",
    "13990.-",
    false,
    { priceNote: { hu: "üveg", en: "bottle" } }
  ),
  i(
    "bosco-prosecco",
    "wine",
    "Bosco Prosecco",
    "Bosco Prosecco",
    "Prosecco",
    "Prosecco",
    "790.- / 4990.-",
    true,
    { priceNote: { hu: "dl / üveg", en: "glass / bottle" } }
  ),
];

const FEATURED_LIMIT = 4;

export function getFeaturedForCategory(categoryId) {
  const inCategory = menuItems.filter((item) => item.categoryId === categoryId);
  const featured = inCategory.filter((item) => item.featured);
  if (featured.length > 0) return featured.slice(0, FEATURED_LIMIT);
  return inCategory.slice(0, FEATURED_LIMIT);
}

export function getItemsForCategory(categoryId) {
  return menuItems.filter((item) => item.categoryId === categoryId);
}

export function getLocalized(field, lang) {
  if (field == null) return "";
  if (typeof field === "string") return field;
  if (Array.isArray(field)) return field;
  const value = field[lang] ?? field.hu;
  return value ?? "";
}
